import { createFileRoute } from '@tanstack/react-router'
import { PapanLaporanDetail } from '../../../../components/PapanLaporanDetail'

export const Route = createFileRoute('/desa/$slug/laporan/$id')({
  component: PapanLaporanDetailPage,
})

function PapanLaporanDetailPage() {
  const { slug, id } = Route.useParams()
  return <PapanLaporanDetail slug={slug} laporanId={id} />
}
